export default "__VITE_ASSET__dsTagQIr__"